document.documentElement.classList.add('js');
document.addEventListener('click',event=>{
  const thumbnail=event.target.closest('[data-gallery-thumbnail]');
  if(!thumbnail)return;
  const image=document.querySelector('[data-product-main-image] img');
  if(!image)return;
  image.src=thumbnail.dataset.imageUrl;
  image.srcset='';
  image.alt=thumbnail.dataset.imageAlt;
  document.querySelectorAll('[data-gallery-thumbnail]').forEach(item=>item.classList.toggle('is-active',item===thumbnail));
});
document.addEventListener('change',event=>{
  if(!event.target.matches('[data-product-option]'))return;
  const form=event.target.closest('[data-product-form]');
  const data=document.querySelector('[data-product-variants]');
  if(!form||!data)return;
  const selected=[...form.querySelectorAll('[data-product-option]')].map(select=>select.value);
  const variants=JSON.parse(data.textContent);
  const variant=variants.find(item=>item.options.every((value,index)=>value===selected[index]));
  const id=form.querySelector('[data-variant-id]');
  const button=form.querySelector('[data-add-to-cart]');
  if(!variant){id.value='';button.disabled=true;button.textContent='Unavailable';return;}
  id.value=variant.id;
  button.disabled=!variant.available;
  button.textContent=variant.available?'Add to cart':'Sold out';
  const price=document.querySelector('[data-product-price]');
  if(price)price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(variant.price/100);
  history.replaceState({},'',`${location.pathname}?variant=${variant.id}`);
});

let cartUpdateTimer;

document.addEventListener('input', event => {
  if (!event.target.matches('[data-cart-quantity]')) return;

  const form = event.target.closest('.cart-form');
  if (!form) return;

  clearTimeout(cartUpdateTimer);
  form.setAttribute('aria-busy', 'true');

  cartUpdateTimer = setTimeout(() => {
    const updateButton = form.querySelector('button[name="update"]');

    if (updateButton && typeof form.requestSubmit === 'function') {
      form.requestSubmit(updateButton);
    } else {
      form.submit();
    }
  }, 500);
});
